import { render, staticRenderFns } from "./LoginCompany.vue?vue&type=template&id=2920ea43&scoped=true&"
import script from "./LoginCompany.vue?vue&type=script&lang=js&"
export * from "./LoginCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2920ea43",
  null
  
)

export default component.exports